export const env = {
  isDev: process.env.NODE_ENV === 'development',
  isProd: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',
  VERSION: process.env.REACT_APP_VERSION || 'unknown',
  API_HOST: process.env.REACT_APP_NEW_API_HOST,
  OLD_API_HOST: process.env.REACT_APP_API_HOST,
  ONETRUST_WEBSITE_ID: process.env.REACT_APP_ONETRUST_WEBSITE_ID,
};
